module.exports = __webpack_public_path__ + "img/image-015.92a421b9.png";